import { useModalStore } from "@/stores/modalStore";
import type { ModalKey, ModalPropsMap } from "@/components/ModalHost/type";

export function useModal<K extends ModalKey>(key: K) {
  const modal = useModalStore((s) => s.modals[key]);
  const closeModal = useModalStore((s) => s.closeModal);

  return {
    open: modal?.open ?? false,
    props: modal?.props as ModalPropsMap[K],
    closeModal: () => closeModal(key),
  };
}
